/* eslint-disable default-param-last */
export const UPDATE_LIST = 'ICD10_UPDATE_LIST'
export const CLEAR_STATE = 'ICD10_CLEAR_STATE'
export const CLEAR_ALL_STATE = 'CLEAR_ALL_STATE'

type IcdItem = {
  id: string
  code: string
  description: string
}

type IcdState = {
  list: IcdItem[]
}

type Action = {
  type: string
  payload?: IcdItem[]
}

const initState: IcdState = {
  list: []
}

export default (
  state: IcdState = initState,
  action: Action
): IcdState => {
  switch (action.type) {
    case CLEAR_STATE:
    case CLEAR_ALL_STATE:
      return initState
    case UPDATE_LIST:
      return {
        ...state,
        list: action.payload || []
      }
    default:
      return state
  }
}
